module.exports = __webpack_public_path__ + "img/Alteralytics.8b1611bd.gif";